import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// 初始状态类型
interface AuthState {
  isAdmin: boolean;
  adminPassword: string;
}

// 初始状态
const initialState: AuthState = {
  isAdmin: localStorage.getItem('isAdmin') === 'true',
  adminPassword: '2333'
};

// 创建 slice
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<string>) => {
      if (action.payload === state.adminPassword) {
        state.isAdmin = true;
        localStorage.setItem('isAdmin', 'true');
      }
    },
    logout: (state) => {
      state.isAdmin = false;
      localStorage.removeItem('isAdmin');
    },
    checkAuth: (state) => {
      state.isAdmin = localStorage.getItem('isAdmin') === 'true';
    }
  }
});

// 导出 actions
export const { login, logout, checkAuth } = authSlice.actions;

// Selectors
export const selectIsAdmin = (state: { auth: AuthState }) => state.auth.isAdmin;

export default authSlice.reducer;